import React, { useRef, useEffect, useState } from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Tooltip } from '@mui/material';

const newsItems = [
    { title: "🔥 $OSCAR Smashes $2.6M in Knights Round", link: "https://x.com/oscartrash2gold/status/1917853999946162410" },
    { title: "👉 Dumpster Destiny Begins: Oscar Presale Live", link: "https://x.com/oscartrash2gold/status/1917146854250234317" },
    { title: "🎁 $OSCAR Airdrop Open - 500 Lucky Winners", link: "https://x.com/oscartrash2gold/status/1909150126859296898" },
    { title: "🔥 Meme Coin Funeral Incoming - Redeem Rugs for Redemption", link: "https://x.com/oscartrash2gold/status/1907712971448418462" },
    { title: "🧠 Grok's Weekly KOL Power Rankings", link: "https://x.com/oscartrash2gold/status/1787495675170623820" },
    { title: "🧹 Cleaning Up Crypto—One Rug at a Time", link: "https://x.com/oscartrash2gold/status/1720760143137087556" },
];

const BreakingNewsTicker = () => {
    const positionRef = useRef(0);


    const tickerRef = useRef(null);
    const contentRef = useRef(null);
    const animationRef = useRef(null);
    const [isPaused, setIsPaused] = useState(false);
    const [hoveredItem, setHoveredItem] = useState(null);
    const speed = 1.5;

    useEffect(() => {
        const ticker = tickerRef.current;
        const content = contentRef.current;
        if (!ticker || !content) return;

        if (positionRef.current === 0) {
            positionRef.current = ticker.clientWidth;
        }

        const animate = () => {
            if (!isPaused) {
                positionRef.current -= speed;
                if (positionRef.current <= -content.scrollWidth) {
                    positionRef.current = ticker.clientWidth;
                }
                content.style.transform = `translateX(${positionRef.current}px)`;
            }
            animationRef.current = requestAnimationFrame(animate);
        };

        animationRef.current = requestAnimationFrame(animate);

        return () => {
            if (animationRef.current) {
                cancelAnimationFrame(animationRef.current);
            }
        };
    }, [isPaused, speed]);

    const handleMouseEnter = (item) => {
        setIsPaused(true);
        setHoveredItem(item);
    };

    const handleMouseLeave = () => {
        setIsPaused(false);
        setHoveredItem(null);
    };

    return (
        <div
            style={{
                width: '100%',
                borderTop: '2px solid #2d9f56',
                borderBottom: '2px solid #2d9f56',
                backgroundColor: '#000',
                display: 'flex',
                alignItems: 'center',
                overflow: 'hidden',
                height: 60,
            }}
        >
            <div
                style={{
                    color: '#2d9f56',
                    fontWeight: 700,
                    padding: '0 20px',
                    whiteSpace: 'nowrap',
                    fontSize: 20,
                    flexShrink: 0,
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                BREAKING:
            </div>
            <div
                ref={tickerRef}
                style={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    flex: 1,
                    position: 'relative',
                    height: '100%',
                }}
            >
                <div
                    ref={contentRef}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        position: 'absolute',
                        height: '100%',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {[...newsItems, ...newsItems].map((item, index, arr) => (
                        <React.Fragment key={`${item.title}-${index}`}>
                            <Tooltip
                                title="View post in new tab"
                                placement="bottom"
                                arrow
                            >
                                <span
                                    onClick={() => window.open(item.link, '_blank')}
                                    onMouseEnter={() => handleMouseEnter(item)}
                                    onMouseLeave={handleMouseLeave}
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        marginRight: 30,
                                        color: hoveredItem === item ? '#2d9f56' : '#e0e0e0',
                                        fontSize: 20,
                                        cursor: 'pointer',
                                        transition: 'color 0.2s',
                                        padding: '0 5px',
                                        height: '100%',
                                    }}
                                >
                                    {item.title}
                                    {hoveredItem === item && (
                                        <OpenInNewIcon
                                            fontSize="small"
                                            style={{
                                                marginLeft: 6,
                                                verticalAlign: 'middle',
                                                color: '#2d9f56',
                                            }}
                                        />
                                    )}
                                </span>
                            </Tooltip>
                            {index !== arr.length - 1 && (
                                <span
                                    style={{
                                        color: '#2d9f56',
                                        marginRight: 30,
                                        fontSize: 22,
                                        userSelect: 'none',
                                    }}
                                >
                                    |
                                </span>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BreakingNewsTicker;
